import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, forwardRef } from 'react';
const CheckBox = forwardRef((props, ref) => {
    const { checked, defaultChecked, disabled = false, name, onChange = () => null, style = {}, } = props;
    const handleCheck = useCallback((e) => {
        onChange(e);
    }, [onChange]);
    return (_jsx("input", { ref: ref, type: "checkbox", name: name, id: name, onChange: handleCheck, checked: checked, defaultChecked: defaultChecked, disabled: disabled, style: style }));
});
export default CheckBox;
